import { z } from "zod"

export type GetOrderEmailReceivers = {
	receivers: GetOrderEmailReceiver[]
}

export type GetOrderEmailReceiver = {
	id: string
	email: string
	categoriesToReceiveMailsFor: GetOrderEmailReceiverSources
}

export type GetOrderEmailReceiverSources = GetOrderEmailReceiverAllCategories | GetOrderEmailReceiverSpecificCategories

export type GetOrderEmailReceiverAllCategories = {
	type: "AllCategories"
}

export type GetOrderEmailReceiverSpecificCategories = {
	type: "SpecificCategories"
	categories: GetOrderEmailReceiverSpecificCategoryInfo[]
}

export type GetOrderEmailReceiverSpecificCategoryInfo = {
	categoryId: string
	categoryName: string
}

export type SetOrderEmailReceivers = {
	receivers: SetOrderEmailReceiver[]
}

export type SetOrderEmailReceiver = {
	id: string
	email: string
	categoriesToReceiveMailsFor: SetOrderEmailReceiverSources
}

export type SetOrderEmailReceiverAllCategories = {
	type: "AllCategories"
}

export type SetOrderEmailReceiverSpecificCategories = {
	type: "SpecificCategories"
	categoryIds: string[]
}

export type SetOrderEmailReceiverSources = SetOrderEmailReceiverAllCategories | SetOrderEmailReceiverSpecificCategories

export const SetOrderEmailReceiverAllCategoriesFormSchema = z.object({
	type: z.literal("AllCategories"),
})

export const SetOrderEmailReceiverSpecificCategoriesFormSchema = z.object({
	type: z.literal("SpecificCategories"),
	categoryIds: z.string().array(),
})

export const SetOrderEmailReceiverSourcesFormSchema = z.discriminatedUnion("type", [
	SetOrderEmailReceiverAllCategoriesFormSchema,
	SetOrderEmailReceiverSpecificCategoriesFormSchema,
])

export type NewOrderEmailReceiverFormSchemaType = z.input<typeof NewOrderEmailReceiverFormSchema>

export const NewOrderEmailReceiverFormSchema = z.object({
	email: z.string().email("Felaktigt format på e-post"),
	categoriesToReceiveMailsFor: SetOrderEmailReceiverSourcesFormSchema,
})
